import { makeAutoObservable } from "mobx";
import { InputShelf } from "../../shelves";

export class Store {
	public birthMonthInput = new InputShelf("");
	public FGTSBalanceInput = new InputShelf("");

	constructor() {
		makeAutoObservable(this);
	}
}
